module.exports = __webpack_public_path__ + "imgs/blaze.9c28a44c4d3500269c72a76865a71e0f.jpg";